/**
 * PB32 — DM Landing Page: Free Mystery Mini Offer
 *
 * Flow:
 * 1. Customer lands on the dedicated offer page (settings.mini_offer_url).
 * 2. Page is detected by URL (path + query, e.g. "?view=c-subscription") → the
 *    offer is active ONLY while on that exact URL; cart attributes are tagged
 *    (Direct Mail attribution) and a popup shows.
 * 3. While on the offer URL, whenever the cart contains ANY subscription line, the
 *    Mystery Mini variant is auto-added as a separate $0 line item labeled
 *    "FREE Mystery Mini Slime".
 * 4. If the subscription is removed, the Mystery Mini is auto-removed — the
 *    customer can't keep it without an active qualifying subscription.
 * 5. A banner at the top of the cart reflects the current state (with / without sub).
 * 6. $0 price is handled by a Shopify AUTOMATIC DISCOUNT (no code) on the variant —
 *    this script only adds/removes the line item.
 *
 * Mirrors assets/mystery-slime-promo.js.liquid (influencer flow), re-scoped to
 * subscription-presence + URL activation instead of discount-code + threshold.
 */

(function() {
  'use strict';

  var CONFIG = {
    enabled: false,
    variantId: '42125443694628',
    pagePath: '/products/mystery-slime-box?view=c-subscription',
    giftLabel: 'FREE Mystery Mini Slime',
    attribution: {
      'Source': 'Direct Mail',
      'Campaign': 'Mystery Mini Offer'
    }
  };

  if (!CONFIG.enabled || !CONFIG.variantId) return;

  var TAGGED_KEY  = 'pb_mini_offer_tagged';    // attribution written this session

  // ── Path / activation helpers ────────────────────

  function normPath(p) {
    return (p || '').replace(/\/+$/, '').toLowerCase();
  }

  // The offer is active ONLY while the visitor is on the offer URL. mini_offer_url
  // may include a query string (e.g. "/products/mystery-slime-box?view=c-subscription").
  // We require BOTH the path and every query parameter in it to match the current
  // location — so the bare product URL (reached from anywhere else) never activates
  // the offer. There is no persisted flag: leave the URL and the offer goes inactive.
  function isOnOfferPage() {
    var parts = String(CONFIG.pagePath || '').split('?');
    if (normPath(window.location.pathname) !== normPath(parts[0])) return false;

    var requiredQuery = parts[1] || '';
    if (!requiredQuery) return true; // no query required → path match is enough

    // Match on the REQUIRED params only; extra params (UTMs from marketing
    // campaigns, etc.) are ignored, in any order. We also normalise stray "?"
    // separators to "&" first — some campaign tools append UTMs with a second
    // "?" (…?view=c-subscription?utm_source=x), which would otherwise corrupt
    // parsing of our param.
    var liveQuery = window.location.search.replace(/^\?/, '').replace(/\?/g, '&');
    var current = new URLSearchParams(liveQuery);
    var required = new URLSearchParams(requiredQuery);
    var matches = true;
    required.forEach(function(value, key) {
      if (current.get(key) !== value) matches = false;
    });
    return matches;
  }

  // ── Attribution (cart attributes → order reporting) ──

  function tagAttribution() {
    if (sessionStorage.getItem(TAGGED_KEY)) return;
    sessionStorage.setItem(TAGGED_KEY, '1');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: CONFIG.attribution })
    }).catch(function(err) {
      console.error('[Mini Offer] Error tagging attribution:', err);
      sessionStorage.removeItem(TAGGED_KEY);
    });
  }

  // ── Cart helpers ─────────────────────────────────

  function getCartState() {
    return fetch('/cart.js', { credentials: 'same-origin', method: 'GET' })
      .then(function(res) { return res.json(); });
  }

  // Subscription lines = any line with a selling plan, excluding the gift itself.
  function subscriptionLines(cart) {
    var out = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (String(item.variant_id) === CONFIG.variantId) continue;
      if (item.selling_plan_allocation) out.push(item);
    }
    return out;
  }

  function hasSubscription(cart) {
    return subscriptionLines(cart).length > 0;
  }

  function findGift(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === CONFIG.variantId) return cart.items[i];
    }
    return null;
  }

  // ── Add / remove gift ────────────────────────────

  var isUpdating = false;
  // Set when the gift was added but did NOT come through at $0 (the Shopify
  // discount Function that zeroes the `_mini-offer` line is missing/disabled).
  // We pull the gift back out and stop re-adding it so the customer is never
  // charged for a "free" gift and the cart doesn't thrash add/remove.
  var giftBlocked = false;
  // Whether a subscription was in the cart on the previous reconcile. The gift is
  // added only on the transition no-sub → sub (i.e. when the customer adds a
  // subscription), NOT on every cycle — so once they remove the gift it stays
  // removed instead of springing back. Reset when the subscription leaves, so a
  // fresh subscription re-offers the gift.
  var lastSubPresent = false;

  // Caller (_reconcile) has already fetched the cart and confirmed the gift is
  // absent, so we skip a redundant /cart.js round-trip and add immediately.
  function addGift() {
    if (isUpdating) return;
    isUpdating = true;

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(CONFIG.variantId, 10),
            quantity: 1,
            properties: { '_mini-offer': 'true' }
          }]
        })
      })
      .then(function(res) { return res.json(); })
      // Safety guard: confirm the gift actually landed at $0 (the discount
      // Function applied). If not, remove it rather than charge the customer.
      .then(function() { return getCartState(); })
      .then(function(cart) {
        var gift = findGift(cart);
        if (gift && gift.final_line_price > 0) {
          giftBlocked = true;
          console.warn('[Mini Offer] Gift not $0 (final_line_price=' +
            gift.final_line_price + '); removing to avoid charging. Check the discount Function.');
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 0 })
          });
        }
      })
      .then(function() { document.dispatchEvent(new CustomEvent('cart:build')); })
      .catch(function(err) { console.error('[Mini Offer] Error adding gift:', err); })
      .finally(function() { isUpdating = false; });
  }

  function removeGift(cart) {
    if (isUpdating) return;
    var gift = findGift(cart);
    if (!gift) return;
    isUpdating = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: gift.key, quantity: 0 })
    })
    .then(function(res) { return res.json(); })
    .then(function() { document.dispatchEvent(new CustomEvent('cart:build')); })
    .catch(function(err) { console.error('[Mini Offer] Error removing gift:', err); })
    .finally(function() { isUpdating = false; });
  }

  // ── Cart DOM: banner + gift line label ───────────

  function getGiftItemEl() {
    var items = document.querySelectorAll('#CartDrawer .cart__item');
    for (var i = 0; i < items.length; i++) {
      var key = items[i].getAttribute('data-key') || '';
      if (key.indexOf(CONFIG.variantId) === 0) return items[i];
    }
    return null;
  }

  function relabelGift() {
    var item = getGiftItemEl();
    if (!item) return;
    var nameEl = item.querySelector('.cart__item-name');
    if (nameEl && nameEl.textContent.trim() !== CONFIG.giftLabel) {
      nameEl.textContent = CONFIG.giftLabel;
    }
  }

  function updateBanner(hasSub) {
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!inner) return;

    var banner = document.getElementById('pb32-mini-banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'pb32-mini-banner';
      banner.className = 'pb32-mini-banner';
      inner.insertBefore(banner, inner.firstChild);
    }
    banner.innerHTML = hasSub
      ? 'Your <strong>FREE Mystery Mini</strong> has been added to your first subscription order'
      : 'Sign up for a subscription and receive a <strong>FREE Mystery Mini</strong> in your first box.';
  }

  function removeBanner() {
    var banner = document.getElementById('pb32-mini-banner');
    if (banner) banner.remove();
  }

  // ── Main reconcile ───────────────────────────────

  var debounce = null;
  function reconcile() {
    clearTimeout(debounce);
    debounce = setTimeout(_reconcile, 50);
  }

  function _reconcile() {
    if (isUpdating) return;
    if (!isOnOfferPage()) { removeBanner(); return; }

    getCartState().then(function(cart) {
      var sub = hasSubscription(cart);
      var gift = findGift(cart);

      // No qualifying subscription → the gift doesn't apply. Pull out any stray
      // gift (fallback for paths the remove-interceptor misses, e.g. dropping
      // the sub to qty 0 via the stepper) and show the "sign up to get it"
      // prompt. The banner is always present while on the offer page.
      if (!sub) {
        if (gift) removeGift(cart);
        updateBanner(false);
        lastSubPresent = false;
        return;
      }

      // Subscription present but no gift.
      if (!gift) {
        // Add the gift only when the subscription was JUST added (no sub last
        // cycle). If the subscription was already here, the gift is absent
        // because the customer removed it — respect that and don't re-add.
        // giftBlocked (discount Function missing) also suppresses the add so we
        // never charge for a "free" gift.
        if (!lastSubPresent && !giftBlocked) {
          lastSubPresent = true;
          addGift();
          return;
        }
        updateBanner(false);
        lastSubPresent = true;
        return;
      }

      // Subscription + gift both present: the happy state.
      updateBanner(true);
      relabelGift();
      lastSubPresent = true;
    }).catch(function(err) {
      console.error('[Mini Offer] Error reconciling cart:', err);
    });
  }

  // When the customer removes the subscription, the theme's native remove handles
  // it; _reconcile then sees no subscription on the next cart:build:complete and
  // pulls out the now-orphaned gift. We intentionally do NOT intercept remove
  // clicks — letting the theme own every removal keeps the cart reliable.

  // ── Events ───────────────────────────────────────

  document.addEventListener('cart:build:complete', reconcile);
  document.addEventListener('cart:open', function() { setTimeout(reconcile, 100); });

  // ── Welcome popup ────────────────────────────────

  // The popup shows on every landing on the offer page — no dismissal memory.
  function showPopup() {
    var overlay = document.createElement('div');
    overlay.className = 'pb32-mini-popup__overlay';
    overlay.innerHTML = ''
      + '<div class="pb32-mini-popup__modal" role="dialog" aria-modal="true" aria-label="Free Mystery Mini offer">'
      +   '<button type="button" class="pb32-mini-popup__close" aria-label="Close">'
      +     '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none">'
      +       '<path d="M25.9 6.1L6.1 25.9" stroke="#282828" stroke-width="2.5" stroke-linecap="round"/>'
      +       '<path d="M25.9 25.9L6.1 6.1" stroke="#282828" stroke-width="2.5" stroke-linecap="round"/>'
      +     '</svg>'
      +   '</button>'
      +   '<div class="pb32-mini-popup__content">'
      +     '<h2 class="pb32-mini-popup__heading">Exclusive Limited Time Offer</h2>'
      +     '<p class="pb32-mini-popup__text">Get a <strong>FREE Mystery Mini</strong> in your first subscription box when you sign up for any plan.</p>'
      +     '<p class="pb32-mini-popup__support">Offer valid for new subscription signups through this page by 7/31/26.</p>'
      +     '<button type="button" class="pb32-mini-popup__cta">Claim Offer</button>'
      +   '</div>'
      + '</div>';

    document.body.appendChild(overlay);
    requestAnimationFrame(function() { overlay.classList.add('pb32-mini-popup--visible'); });

    function close() {
      overlay.classList.remove('pb32-mini-popup--visible');
      setTimeout(function() { overlay.remove(); }, 300);
    }
    overlay.querySelector('.pb32-mini-popup__close').addEventListener('click', close);
    overlay.querySelector('.pb32-mini-popup__cta').addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
  }

  // ── Init ─────────────────────────────────────────

  if (isOnOfferPage()) {
    tagAttribution(); // Direct-Mail attribution → carries into the order
    if (document.readyState === 'complete') {
      setTimeout(showPopup, 800);
      reconcile(); // in case the visitor arrives with a cart already built
    } else {
      window.addEventListener('load', function() {
        setTimeout(showPopup, 800);
        reconcile();
      });
    }
  }

})();
